<template>
  <div>
    <div style="font-size: 22px" class="pl-4 mt-4">
      สำนักงานส่งเสริมเศรษฐกิจดิจิทัลเขตพื้นที่ภาคใต้ สาขาภาคใต้ตอนล่าง
    </div>
    <v-divider></v-divider>
    <div class="pa-5">
      <v-row dense>
        <v-col cols="2">
          <v-icon size="30px">mdi-map-marker-outline</v-icon>
        </v-col>
        <v-col cols="10">
          <div class="pl-0">
            มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตหาดใหญ่
            อาคารคณะการจัดการสิ่งแวดล้อม ห้องE206 ชั้น 2 15 ถนนกาญจนวนิชย์
            ต.คอหงส์ อ.หาดใหญ่ จ.สงขลา 90110
          </div>
          <div class="mt-4">
            <div>Tel : 08-2258-8599</div>
            <!-- <div>Fax : (+66) 0-7637-9000</div> -->
          </div>
          <div class="mt-4">
            <!-- <div>Email : Doss@depa.or.th</div> -->
          </div>
        </v-col>
      </v-row>
      <div
        class="mt-6"
        style="position: relative; width: 100%; height: 0; padding-top: 100%"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1980.0138844510539!2d100.49823!3d7.006013!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc54c1d4c585e0bdc!2z4Lia4Lix4LiT4LiR4Li04LiV4Lin4Li04LiX4Lii4Liy4Lil4Lix4LiiIOC4oeC4q-C4suC4p-C4tOC4l-C4ouC4suC4peC4seC4ouC4quC4h-C4guC4peC4suC4meC4hOC4o-C4tOC4meC4l-C4o-C5jA!5e0!3m2!1sen!2sth!4v1617784491046!5m2!1sen!2sth"
          style="
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
          "
          frameborder="0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>